import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import ScenarioStatus from './components/ScenarioStatus';
import { formatBangkokDateTime } from './utils/bangkokTime';



// Paginated scenario list. Selecting a row triggers onSelect(scenario.id) — the parent fetches
// the detail directly via useScenarioDetail rather than relying on whatever this list happened
// to have cached, so a scenario on page 3 is just as selectable as one on page 1
// (ASSESSMENT.md P2).
export default function ScenarioList({ state, page, onPageChange, selectedId, onSelect }) {
  const { loading, error, results, count, next, previous } = state;

  if (loading && !results.length) {
    return <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 160 }}><CircularProgress size={28} /></Box>;
  }

  if (error) {
    return <Alert severity="error">{error.summary}</Alert>;
  }

  if (!results.length) {
    return <Typography color="text.secondary">No scenarios yet for this plant/factory. Create one above.</Typography>;
  }



  return (
    <Stack spacing={1.5}>
      <Box sx={{ overflowX: 'auto' }}>
        <Box component="table" sx={{ width: '100%', minWidth: 720, borderCollapse: 'collapse', '& th, & td': { p: 0.75, borderBottom: '1px solid', borderColor: 'divider' }, '& th': { textAlign: 'left', fontWeight: 600 } }}>
          <thead>
            <tr>{['ID', 'Status', 'Planning window', 'Created', ''].map((label) => <th key={label}>{label}</th>)}</tr>
          </thead>
          <tbody>
            {results.map((scenario) => (
              <tr
                key={scenario.id}
                style={{ background: String(scenario.id) === String(selectedId) ? 'rgba(25,118,210,0.08)' : undefined }}
              >
                <td>#{scenario.id}</td>
                <td><ScenarioStatus status={scenario.status} reason={scenario.status_reason} /></td>
                <td>{formatBangkokDateTime(scenario.planning_start)} → {formatBangkokDateTime(scenario.planning_end)}</td>
                <td>{scenario.created_at ? formatBangkokDateTime(scenario.created_at) : '—'}</td>
                <td>
                  <Button size="small" onClick={() => onSelect(scenario.id)}>
                    {String(scenario.id) === String(selectedId) ? 'Selected' : 'Open'}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Box>
      </Box>
      <Stack direction="row" spacing={1} alignItems="center">
        <Button size="small" disabled={loading || !previous} onClick={() => onPageChange(page - 1)}>Previous</Button>
        <Typography variant="body2">Page {page} · {count} scenarios</Typography>
        <Button size="small" disabled={loading || !next} onClick={() => onPageChange(page + 1)}>Next</Button>
      </Stack>
    </Stack>
  );
}
